import { Grid } from '@mui/material';
import React, { forwardRef } from 'react'
import styles from './../../../../../assets/styles/componentStyles/chatLogsStyles/chatLogsTemplatePreview.module.scss'
import ReplyIcon from '@mui/icons-material/Reply';
import ListIcon from '@mui/icons-material/List';
import IconsColor from '../../../../../components/utility/iconsColor';
import { primaryColor } from '../../../../../utils/colors';
import globalStyles from './../../../../../assets/styles/global.module.scss'
import { isMediaHeaderInTemplate } from '../../../../../components/dashboard/flowBuilder/flowBuilderConstants';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { replacingTemplateMarkdownText } from '../../../../../utils/constants';

const WaInteractiveMessagePreview = forwardRef((props: any, targetRef: any) => {
    const { interactiveObj } = props;
    const [open, setOpen] = React.useState(false);



    const getSubButtonIcon = (type: string) => {
        switch (type) {
            case 'reply':
                return <ReplyIcon className={`${styles.previewSubButton} ${globalStyles.displayFlex}`} />
            case 'flow':
                return <IconsColor iconName="form" width="15px" height="15px" fillColor={primaryColor} />
            case 'cta_url':
                return <OpenInNewOutlinedIcon className={`${styles.previewSubButton} ${globalStyles.displayFlex}`} />;
            // case 3:
            //     return <OpenInNewOutlinedIcon style={{ display: "flex" }} className={styles.previewSubButton} />;
            // case 4:
            //     return <CallIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            // case 2:
            //     return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            // case 1:
            //     return <ReplyIcon style={{ display: "flex" }} className={styles.previewSubButton} />
            // case null:
            //     return ""
            default:
                return <ListIcon className={`${styles.previewSubButton} ${globalStyles.displayFlex}`} />
        }
    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData?.wa_button_field_data?.filter((field: any) => field.field_name == "Button Text")[0]

        return fieldVal?.wa_template_button_sub_type_field_value
    }
    function getHeaderVal(type: string, headerObj: any) {
        switch (type) {
            case 'text': {
                return <Grid item className={styles.templatePrviewHeaderItem}>
                    {headerObj.text}
                </Grid>

            }
            case 'image': {
                return <Grid item className={`${styles.hiddenOverflowStyle} ${props.isCarouselTemplate && styles.hiddenOverflowStyleCarouselTemplte}`}>
                    <img alt=";php" src={headerObj.image.link} className={`${styles.templatePreviewHeaderImage} ${props.isCarouselTemplate && styles.templatePreviewHeaderImageForCarouseltemplate}`} />
                </Grid>

            }
            case 'video': {
                return <Grid item className={styles.hiddenOverflowStyle}>
                    <video style={{ width: "100%", maxHeight: "200px" }} controls className='video-tag'>
                        <source src={headerObj.video.link || ""} type="video/mp4" />
                    </video>
                </Grid>
            }
            case 'document': {
                return
            }
        }
    }
    function getInteractiveButtons(type: string) {
        switch (type) {
            case 'button':
                return <>
                    {
                        interactiveObj.action?.buttons.length > 0 && interactiveObj.action?.buttons?.map((btnData: any, ind: number) => {
                            return <Grid item key={ind} paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                    <Grid item className={globalStyles.displayFlex}>
                                        {getSubButtonIcon(btnData.type)}
                                    </Grid>
                                    <Grid item>
                                        {btnData.reply.title}
                                    </Grid>
                                </Grid>
                            </Grid>
                        })
                    }
                </>
            case 'flow': {
                return <>

                    <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                            <Grid item className={globalStyles.displayFlex}>
                                {getSubButtonIcon(interactiveObj.type)}
                            </Grid>
                            <Grid item>
                                {interactiveObj.action?.parameters.flow_cta}
                            </Grid>
                        </Grid>
                    </Grid>

                </>
            }
            case 'catalog_message': {
                return <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                        <Grid item>
                            View Catalog
                        </Grid>
                    </Grid>
                </Grid>
            }
            case 'cta_url': {
                return <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                            <Grid item className={globalStyles.displayFlex}>
                                {getSubButtonIcon(interactiveObj.type)}
                            </Grid>
                            <Grid item>
                                {interactiveObj.action?.parameters?.display_text}
                            </Grid>
                        </Grid>
                </Grid>
            }
        }
    }
    return (
        <>
            <Grid item
                padding={"0px"} className={`${styles.previewSectionCardBlock} ${props.isCarouselTemplate && styles.previewSectionCardBlockForCarouselTemplate}`}>
                <Grid container direction={"column"}>
                    {interactiveObj.header &&
                        getHeaderVal(interactiveObj?.header?.type, interactiveObj.header)
                    }
                    <Grid item className={`${(interactiveObj.header && isMediaHeaderInTemplate(interactiveObj?.header?.type)) ? styles.templatePrviewBodyItem : styles.templatePrviewBodyItemWithMediaHeader}`} mb={"4px"}>
                        <pre
                            className={styles.preTextStyle}
                            dangerouslySetInnerHTML={{ __html: replacingTemplateMarkdownText(interactiveObj?.body?.text ?? '') }}
                        />
                    </Grid>
                    {interactiveObj.footer &&
                        <Grid item className={styles.templatePrviewFooterItem}>
                            {interactiveObj.footer.text}
                        </Grid>
                    }
                    {/* {
                        actionData.wa_button_data?.length > 3 && actionData.wa_button_data?.length > 3 && actionData.wa_button_data?.slice(0, 2)?.sort((button1: any, button2: any) => button1.index - button2.index)?.map((btnData: any) => {
                            return <>
                                <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                    <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                        <Grid item>
                                            {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                                        </Grid>
                                        <Grid item>
                                            {getSubButtonText(btnData)}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        })
                    }
                    {actionData.wa_button_data?.length > 3 &&
                        <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}
                            onClick={toggleDrawer1(true)}
                        >
                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                <Grid item>
                                    <MenuIcon style={{ display: "flex" }} />
                                </Grid>
                                <Grid item>
                                    See all options
                                </Grid>
                            </Grid>
                        </Grid>
                    } */}
                </Grid>
                {getInteractiveButtons(interactiveObj.type)}
            </Grid>
            {/* <Drawer
                open={open}
                anchor='bottom'
                ref={targetRef ? targetRef.current : ""}
                onClose={toggleDrawer1(false)}
                variant="temporary"
                ModalProps={{
                    container: targetRef ? targetRef.current : "",
                    disableEnforceFocus: true,
                    style: { position: 'absolute' },
                    keepMounted: false,
                }}
                PaperProps={{
                    container: targetRef ? targetRef.current : "",
                    style: { position: 'absolute' },
                }}
                sx={{
                    transition: open ? 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    position: "absolute"
                }}
                BackdropProps={{ style: { position: "absolute" } }}
                SlideProps={{
                    direction: open ? "up" : "down",
                    timeout: { enter: 0, exit: 0 },
                    style: {
                        borderRadius: "32px 32px 0px 0px",
                        border: "2px solid #FAF0F0",
                        padding: "15px",
                        transition: open ? 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                    }
                }}
            >
                <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                    <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                        <Box className={styles.drawerContainerBoxDetail}></Box>
                    </Grid>
                    <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                        <CloseIcon className={styles.closeDrawerIconStyle} onClick={() => setOpen(false)} />
                        <span className={styles.allOptionTextStyle}>All Options</span>
                    </Grid>
                </Grid>
                {
                    actionData.wa_button_data?.length > 0 && actionData.wa_button_data?.sort((button1: any, button2: any) => button1.index - button2.index)?.map((btnData: any) => {
                        return <Grid item paddingBlock={"10px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                            <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                <Grid item>
                                    {getSubButtonIcon(btnData.wa_template_button_sub_type_id)}
                                </Grid>
                                <Grid item>
                                    {getSubButtonText(btnData)}
                                </Grid>
                            </Grid>
                        </Grid>
                    })
                }
            </Drawer> */}
        </>
    )
});

export default WaInteractiveMessagePreview
